import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FiCalendar, FiMessageSquare } from "react-icons/fi";

const CTA = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleSchedule = () => {
    window.open("https://calendly.com", "_blank");
  };

  const handleConsultation = () => {
    navigate("/contactus");
  };

  return (
    <section className="py-20 md:py-28 bg-slate-50 dark:bg-[#0c0c0e] transition-colors duration-500 overflow-hidden relative">
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative rounded-3xl overflow-hidden py-16 px-8 md:px-16 text-center bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 dark:from-purple-900/60 dark:via-indigo-900/40 dark:to-blue-950/60 border border-slate-200/20 dark:border-neutral-800/30 shadow-2xl"
        >
          {/* Animated glow background elements */}
          <div className="absolute inset-0 opacity-20 dark:opacity-30 mix-blend-overlay bg-[linear-gradient(45deg,#000_25%,transparent_25%),linear-gradient(-45deg,#000_25%,transparent_25%)] bg-[size:20px_20px] pointer-events-none" />
          
          <div className="absolute -top-24 -left-24 w-60 h-60 rounded-full bg-blue-400/30 blur-3xl pointer-events-none" />
          <div className="absolute -bottom-24 -right-24 w-60 h-60 rounded-full bg-purple-400/30 blur-3xl pointer-events-none" />

          <div className="relative z-10 max-w-2xl mx-auto flex flex-col items-center gap-6">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-white tracking-tight leading-tight">
              {t('cta_headline', "Let's Build Something Amazing Together")}
            </h2>
            
            <p className="text-slate-100 dark:text-neutral-300 text-sm sm:text-base leading-relaxed">
              {t('cta_subheadline', "Unleash your software potential. Partner with Softkel's engineering team today to turn your product vision into reality.")}
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-4 w-full sm:w-auto">
              {/* <button
                onClick={handleSchedule}
                className="group flex items-center justify-center gap-2 px-6 py-3.5 w-full sm:w-auto text-sm font-semibold rounded-xl bg-white hover:bg-slate-100 text-blue-700 hover:text-blue-800 shadow-lg transition-all duration-300 hover:-translate-y-0.5 active:translate-y-0"
              >
                <FiCalendar className="w-4 h-4 text-blue-700" />
                <span>{t('schedule_meeting', 'Schedule a Meeting')}</span>
              </button> */}

              <button
                onClick={handleConsultation}
                className="group flex items-center justify-center gap-2 px-6 py-3.5 w-full sm:w-auto text-sm font-semibold rounded-xl bg-blue-500/20 hover:bg-blue-500/30 text-white border border-white/30 hover:border-white/50 backdrop-blur-md transition-all duration-300 hover:-translate-y-0.5 active:translate-y-0"
              >
                <FiMessageSquare className="w-4 h-4 text-white" />
                <span>{t('free_consultation_btn', 'Get Free Consultation')}</span>
              </button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTA;
export { CTA };
